import { P0, S, abs, arc, fillAt, max, sq } from '../../geometry';

export const hamster = {
  name: 'Hamster',
  colors: ['#C46A3E', '#161616'],
  draw(m, t) {
    let w1 = 1.5 * S(t * 3),
      w2 = 1.5 * S(t * 3 + 1),
      hw = 27,
      ear = 0,
      pose = P0();
    if (m === 'happy') {
      w1 = 4 * S(t * 16);
      w2 = 4 * S(t * 16 + 1);
      ear = -2.5 * abs(S(t * 6));
      pose.ty = -2.5 * abs(S(t * 6));
    }
    // Thinking: whiskers keep twitching, head tilting side to side.
    if (m === 'thinking') {
      w1 = 4 * S(t * 7);
      w2 = 4 * S(t * 7 + 2);
      pose.rot = 4 * S(t * 1.4);
    }
    if (m === 'talking') hw = 27 + 3.5 * max(0, S(t * 10));
    if (m === 'surprised') {
      ear = -4;
      w1 = -4;
      w2 = 4;
    }
    if (m === 'paused') {
      pose.sy = 0.92;
      pose.ty = 2;
      w1 = w2 = 2;
    }
    const wh = (y, w, dir) => [
      [50 + dir * 26, y],
      [50 + dir * 39, y - 3 + w],
    ];
    return {
      strokes: [
        { c: 'a', pts: arc(32, 38 + ear, 6.5, -90, 270, 11), n: 16 },
        { c: 'a', pts: arc(68, 38 + ear, 6.5, -90, 270, 11), n: 16 },
        { c: 'a', pts: sq(50, 60, hw, 23, 2.3), n: 30 },
        { c: 'b', pts: wh(63, w1, -1) },
        { c: 'b', pts: wh(69, w2, -1) },
        { c: 'b', pts: wh(63, w1, 1) },
        { c: 'b', pts: wh(69, w2, 1) },
      ],
      eyes: { x: 50, y: 56 },
      pose,
    };
  },
  eyesOn: 'a',
  solid: (f) => fillAt(f, 0, 1, 2),
};
